import type { LatLng, LatLngExpression } from "leaflet";
import L from "leaflet";
import * as _ from "lodash";

import Collections from "./collections";
import Converter from "./converter";
import Movements from "./movements";
import { getNearestGridPoint } from "./snapping-utils";

interface Viewport {
    zoom: number;
    center: LatLngExpression;
}

type LatLngLike = Pick<LatLng, "lat" | "lng">;

class Map {
    Collections: typeof Collections;

    Converter: typeof Converter;

    _viewport: Viewport;

    constructor() {
        this._viewport = {
            zoom: 5,
            center: [0, 0],
        };
        this.Collections = Collections;

        this.Converter = Converter;
        this.setViewport = this.setViewport.bind(this);
    }

    moveLight = (
        direction: keyof typeof Movements,
        position: { x: number; y: number },
        distance: number,
    ) => Movements[direction](position, distance);

    setViewport({ zoom, center }: Partial<Viewport>) {
        this._viewport = _.defaultsDeep({}, { zoom, center }, this._viewport);
    }

    get viewport() {
        return this._viewport;
    }

    distanceBetweenPoints(pointA: LatLngLike, pointB: LatLngLike) {
        const start = L.point(pointA.lng, pointA.lat);
        const end = L.point(pointB.lng, pointB.lat);
        return start.distanceTo(end);
    }

    subtractLatLng(pointA: LatLngLike, pointB: LatLngLike) {
        return {
            lat: pointA.lat - pointB.lat,
            lng: pointA.lng - pointB.lng,
        };
    }

    getNearestGridPoint(
        point: LatLngLike,
        tileSizeX: number,
        tileSizeY: number,
        gridOffSetX: number,
        gridOffSetY: number,
    ): LatLng {
        return getNearestGridPoint(
            point,
            tileSizeX,
            tileSizeY,
            gridOffSetX,
            gridOffSetY,
        );
    }
}

export * from "./legend-icon-utils";
export * from "./light-array-utils";
export * from "./light-style-utils";
export * from "./snapping-utils";

export default new Map();
